import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="bg-gray-800 text-gray-300 py-8">
      <div className="container mx-auto px-4">
        <div className="text-center mb-6">
          {/* Navigation Links */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">
              Quick Links
            </h3>
            <ul className="flex align-items-center gap-20 justify-center flex-wrap">
              <li>
                <Link to="/" className="hover:text-blue-400">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-blue-400">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/whatsnew" className="hover:text-blue-400">
                  What's New
                </Link>
              </li>
              <li>
                <Link to="/terms" className="hover:text-blue-400">
                  Terms
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-blue-400">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/feedback" className="hover:text-blue-400">
                  Feedback
                </Link>
              </li>
              <li>
                <Link to="/faqs" className="hover:text-blue-400">
                  FAQs
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 text-center text-sm text-white">
          © {new Date().getFullYear()} Kalam Dreams Labs. All rights reserved.
        </div>
      </div>
    </footer>
  );
}

export default Footer;